export enum CompressorImageTags {
  MachineDataTag = 'machine-data-tag',
  ControllerFront = 'controller-front',
  ControllerBack = 'controller-back',
  ElectricalCabinet = 'electrical-cabinet',
  IncomingWiring = 'incoming-wiring',
  Other = 'other',
}

export enum SensorImageTags {
  PipeFocused = 'pipe-focused',
  PipePanoramaVideo = 'pipe-panorama-video',
  Sensor = 'sensor',
  Other = 'other',
}

export enum OtherDeviceImageTags {
  Other = 'other',
}
